import { render, staticRenderFns } from "./InterestingCreate.vue?vue&type=template&id=4172205e"
import script from "./InterestingCreate.vue?vue&type=script&lang=js"
export * from "./InterestingCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports